/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_HelperInputs */

const es_admin_users_invite_helper = /** @type {(inputs: Admin_Users_Invite_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El usuario recibirá un email para unirse a tu tenant de Nexata.`)
};

const en_admin_users_invite_helper = /** @type {(inputs: Admin_Users_Invite_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user will receive an email to join your Nexata tenant.`)
};

/**
* | output |
* | --- |
* | "The user will receive an email to join your Nexata tenant." |
*
* @param {Admin_Users_Invite_HelperInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_helper = /** @type {((inputs?: Admin_Users_Invite_HelperInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_HelperInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_helper(inputs)
	return en_admin_users_invite_helper(inputs)
});
export { admin_users_invite_helper as "admin.users.invite.helper" }